// @ts-nocheck
export const sendGTMEvent = (event: string, params: Record<string, any>) => {
  if (typeof window !== 'undefined' && process.env.NEXT_PUBLIC_APP_ENV === 'production') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  }
};  